<p [matTooltip]="label" [class.selected]="selected" (click)="onSelected()"></p>
